module.exports = __webpack_public_path__ + "media/fonts/SFProText-Regular-ebbb25d0408384a6398ce4ce2d914343.woff2";